const notUndefined = (value) => typeof value !== 'undefined';

export { notUndefined };
